import { render, staticRenderFns } from "./create-activity.vue?vue&type=template&id=5f18b692&scoped=true&"
import script from "./create-activity.vue?vue&type=script&lang=js&"
export * from "./create-activity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f18b692",
  null
  
)

export default component.exports